<template>
  <VCombobox
    v-model="address"
    :items="addresses"
    :loading="isLoading"
    :search-input.sync="search"
    append-icon=""
    hide-no-data
    no-filter
    outlined
    dense
    item-text="address"
    :label="$t('startTypingAddress')"
    :hide-details="!errors.length"
    :error-messages="errors"
    return-object
    @input="selected"
    @update:search-input="$emit('input', $event)"
  />
</template>

<script>
import debounce from 'lodash.debounce';
import { response } from '../../orm/functions';
import Address from '../../orm/models/Address/Address';

export default {
  name: 'AddressGeocodeInput',
  model: {
    prop: 'value',
    event: 'selected',
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      address: this.value,
      addresses: [],
      search: null,
      callApi: debounce(async (address) => {
        if (!address || this.addresses.some((a) => a.address === address)) {
          this.addresses = [];
          return;
        }
        this.isLoading = true;
        try {
          this.addresses = await response(Address.api().geocode(address));
          this.checkConvergence(this.search);
          this.$emit(this.addresses.length ? 'found' : 'not-found');
        } finally {
          this.isLoading = false;
        }
      }, 1000),
    };
  },
  watch: {
    search(address) {
      this.callApi(address);
      this.checkConvergence(address);
    },
  },
  methods: {
    selected(data) {
      if (typeof data !== 'string') {
        this.$emit('selected', data);
      }
    },
    checkConvergence(address) {
      if (this.addresses.some((a) => a.address === address)) {
        this.$emit('converged');
      } else {
        this.$emit('diverged');
      }
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  startTypingAddress: Start typing the address
</i18n>

<i18n locale="ru" lang="yaml">
  startTypingAddress: Начните вводить адрес
</i18n>
